import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { templatesService } from '../api/templates.service';
import { TEMPLATE_KEYS } from './queryKeys';
import type { TemplatesFilters } from '../types';

export function useTemplates(
  filters: TemplatesFilters,
  page: number,
  pageSize: number,
  enabled = true,
) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: TEMPLATE_KEYS.list(orgId ?? '', filters, page, pageSize),
    queryFn: ({ signal }) => templatesService.getList(filters, page, pageSize, signal),
    staleTime: 60_000,
    enabled: !!orgId && enabled,
    placeholderData: keepPreviousData,
  });

  return {
    templates: data?.data.items ?? [],
    pageInfo: data?.data,
    isLoading,
    isError,
  };
}
